export const EWASTE_SERVICE_ID = 'SID102';

export const WeekDays = [
  {
    label: 0,
    value: 'Sunday'
  },
  {
    label: 1,
    value: 'Monday'
  },
  {
    label: 2,
    value: 'Tuesday'
  },
  {
    label: 3,
    value: 'Wednesday'
  },
  {
    label: 4,
    value: 'Thursday'
  },
  {
    label: 5,
    value: 'Friday'
  },
  {
    label: 6,
    value: 'Saturday'
  },
];
